export const secondsToPrettyMinutes = (minutes: number): string => {
  const totalSeconds = Math.round(minutes * 60);
  const mins = Math.floor(totalSeconds / 60);
  const secs = totalSeconds % 60;

  // Constructing the output based on the calculated mins and secs
  if (mins === 0) {
    return `${secs} ${secs === 1 ? "second" : "seconds"}`;
  } else {
    return `${mins} ${mins === 1 ? "minute" : "minutes"}${secs > 0 ? ` ${secs} ${secs === 1 ? "second" : "seconds"}` : ""}`;
  }
};
